import type { Signal } from '@angular/core';
import { computed } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import type { TextField } from '@sitecore-jss/sitecore-jss-angular';

import type { ContentSectionTheme } from './content-section.model';

export const computedContentSectionId = (
  rendering: Signal<InnogyComponentRendering | undefined>
) => computed(() => getContentSectionId(rendering()));

export const computedContentSectionTheme = (
  rendering: Signal<InnogyComponentRendering | undefined>
) => computed(() => getContentSectionTheme(rendering()));

export const computedContentSectionTitle = (
  rendering: Signal<InnogyComponentRendering | undefined>
) => computed(() => getContentSectionTitle(rendering()));

/** @deprecated your component should be migrated to signals and use the @see:computedContentSectionId **/
export const getContentSectionId = (
  rendering: InnogyComponentRendering | undefined
) => {
  const anchor = (rendering?.fields?.['anchor'] as TextField)?.value;
  const uid = rendering?.uid;

  if (anchor) {
    return anchor;
  }

  if (uid) {
    return `section-${uid}`;
  }

  return undefined;
};

/** @deprecated your component should be migrated to signals and use the @see:computedContentSectionTheme **/
export const getContentSectionTheme = (
  rendering: InnogyComponentRendering | undefined
) => rendering?.params?.['theme'] as ContentSectionTheme | undefined;

/** @deprecated your component should be migrated to signals and use the @see:computedContentSectionTitle **/
export const getContentSectionTitle = (
  rendering: InnogyComponentRendering | undefined
): TextField | undefined => {
  const field = rendering?.fields?.['sectionTitle'];
  if (field && typeof (field as TextField).value === 'string') {
    return field as TextField;
  }
  return undefined;
};
